import { permissions } from './Constants'

const getUserPermissions = (role) => permissions[role] || []

export default getUserPermissions
